import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import ReactEcharts from 'echarts-for-react';
import {
  closeTest
} from '../../actions/client';
import {
  NF_TEST,
  LA_TEST,
  RR_TEST,
} from '../../constants.js';
import s from './TestResult.css';

class TestResult extends PureComponent {

  closeTest() {
    this.props.closeTest();
  }

  testTitle(name) {
    switch(name) {
      case NF_TEST:
        return 'The Big Picture Assessment';
      case LA_TEST:
        return 'Loss Aversion';
      case RR_TEST:
        return 'Retirement Regret';
      default:
        return '';
    }
  }

  render() {
    const {
      activeTest,
      activeTestResult,
    } = this.props;
    let showCompare = true;
    if (window.matchMedia('(max-device-width: 1200px)').matches) {
      showCompare = false;
    }
    return (
      <div>
        <div className="row">
          <div className="col-md-12">
            <div className={s.headerRow}></div>
            <div className={s.headerTitle}>
              {this.testTitle(activeTest)} Complete!
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-1" />
          <div className="col-md-10">
            {!activeTestResult &&
              <div key="score" className={s.copy}>
              Analyzing your results...
              </div>
            }
            {activeTestResult &&
              <div>
                <div key="score" className={s.copy} dangerouslySetInnerHTML={{__html: activeTestResult.result}} />
                {activeTest === LA_TEST && showCompare &&
                  <div>
                    <div className={s.copy}><br /><strong>How do you compare to others?</strong><br /><br /></div>
                    <ReactEcharts option={ this.getChart(activeTestResult.score) } style={{ height: 200 }} />
                  </div>
                }
              </div>
            }
          </div>
          <div className="col-md-1" />
        </div>
        <div className="row">
          <div className="col-md-12" style={{textAlign: 'center'}}>
            <button onClick={() => this.closeTest()} className={s.answerButton}>DONE</button>
          </div>
        </div>
      </div>
    );
  }

  getChart(scores) {
    const score = scores[0];
    let idx;
    if(score < 1.15) {
      idx = 0;
    } else if (score < 4) {
      idx = 1;
    } else {
      idx = 2;
    }
    const colors = ['#8C959B','#8C959B','#8C959B'];
    colors[idx] = '#35ccd2';
    const labelTop = {
      show: true,
      fontSize:20,
      fontWeight:'bold',
      color:'#FFFFFF',
      position: 'insideBottom',
    };
    return {
      color: colors,
      grid: {
          top: '30',
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true,
      },
      xAxis : [
        {
          type : 'category',
          data : ['Gain Seeking or Experience Gains & Losses Equally', 'Loss Averse', 'More Loss Averse'],
          axisLine: {
            lineStyle: {
                color: '#5b6770',
            },
          },
          axisTick: {
            show: false,
            interval: function () {
              return 1;
            },
          },
          axisLabel: {
            show: true,
            fontSize: 14,
            interval: function () {
              return 1;
            },
          },
        },
      ],
      yAxis : [
        {
          type : 'value',
          max: 36,
          axisLabel: {show: false},
          axisTick: {show: false},
          splitLine: {show: false},
          axisLine: {show: false},
        },
      ],
      series : [
        {
          type: 'bar',
          barWidth: '90%',
          barGap:'-100%',
          silent: true,
          data: [{value: 36, label: labelTop},0,0],
          label: {
            normal: {
                show: false,
                formatter: function (params) {
                  if(params.value === 36) {
                    return '36%';
                  } else {
                    return '';
                  }
                },
            },
          },
        },
        {
          type: 'bar',
          barWidth: '90%',
          barGap:'-100%',
          silent: true,
          data: [0,{value: 31, label: labelTop},0],
          label: {
            normal: {
                show: false,
                formatter: function (params) {
                  if(params.value === 31) {
                    return '31%';
                  } else {
                    return '';
                  }
                },
            },
          },
        },
        {
          type: 'bar',
          barWidth: '90%',
          barGap:'-100%',
          silent: true,
          data: [0,0,{value: 33, label: labelTop}],
          label: {
            normal: {
                show: false,
                formatter: function (params) {
                  if(params.value === 33) {
                    return '33%';
                  } else {
                    return '';
                  }
                },
            },
          },
        },
      ],
    };
  }
}

function mapStateToProps(state) {
  return {
    activeTest: state.clientData.activeTest,
    activeTestResult: state.clientData.activeTestResult,
  };
}

export default connect(mapStateToProps, {
  closeTest,
})(TestResult);



// WEBPACK FOOTER //
// ./src/components/ClientMode/TestResult.js